import { Button, Input, Text } from "@ttc3k/trekker";
import { useTranslation } from "react-i18next";
import { Box, Flex } from "styled-system/jsx";
import {
  useBackOfficeCrowdRiff,
  UseBackOfficeCrowdRiffProps,
} from "./useBackOfficeCrowdRiff";

export const BackOfficeCrowdRiffFlyoutSection = (
  props: UseBackOfficeCrowdRiffProps,
) => {
  const { t } = useTranslation();
  const { value, setValue, isSaving, isLoading, isDirty, onSave } =
    useBackOfficeCrowdRiff(props);

  return (
    <Flex flexDir="column" gap="200">
      <Flex alignItems="center" justifyContent="space-between" gap="200">
        <Text visual="bodySemiBold">
          {t("directory:OPERATOR.FLYOUT.CROWDRIFF_ID")}
        </Text>
        <Button
          visual="primary"
          mode="dark"
          size="sm"
          onClick={() => onSave(value)}
          disabled={isSaving || isLoading || !isDirty}
          isLoading={isSaving}
        >
          {t("directory:OPERATOR.BACK_OFFICE.CROWDRIFF.SAVE_BUTTON")}
        </Button>
      </Flex>
      <Box borderTopWidth="1px" borderColor="border.light" pt="200" />
      <Input
        value={value}
        onChange={e => setValue(e.target.value)}
        placeholder={t("directory:OPERATOR.BACK_OFFICE.CROWDRIFF.PLACEHOLDER")}
        disabled={isSaving || isLoading}
        bg="white"
        style={{ width: "100%" }}
      />
    </Flex>
  );
};
